import { FUNDING, PayPalButtons } from "@paypal/react-paypal-js";
import {
  ErrorMessage,
  Field,
  Form,
  Formik,
  useField,
  useFormikContext,
} from "formik";
import { useContext, useEffect, useState } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { CameraIcon, StripeIcon } from "../../Assets/svgIcons";
import { useAuth } from "../../Contexts/auth.context";
import { ReactComponent as CloseIcon } from "../../icons/close.svg";
import {
  StyledTable,
  TableContainer,
} from "../../Pages/Public/billing-history/billing-history.styles.jsx";
import {
  CMModalConfirmation,
  customStyles,
  customStylesConfirmationModal,
  customStylesDeposit,
  Title,
} from "../../Pages/RegisteredTrader/add-funds/add-funds.styles";
import { getAuctionDefaultValues } from "../../Services/auction.service";
import {
  addDeposit,
  addManualDeposit,
  addWithdraw,
  depositWithdrawAmountLimit,
  getAdminBankDetails,
  getProfile,
  getWalletBalance,
  getWalletSetting,
  payment_transaction,
  user_profile,
} from "../../Services/prod/auth.service";
import { getAuthMapping } from "../../Utils/authmapping.utils";
import Button from "../button/button.component";
import { Context } from "../Context/ContextComponent";
import Loading from "../loading/loading.component";
import { CMCloseButton } from "../place-bid/place-bid/place-bid.styles";
import "./AddFounds.scss";
import MainStripe from "./MainStripe.component";
import { formatCommaNumbers } from "../../Utils/common.utils.jsx";
import LoadingChild from "../loading-child/loading-child.component.jsx";
import pdf from "../../Assets/pdf1.png";
import MethodModal from "./MethodModal.jsx";

const AddFunds = ({
  setSuccessfullTransaction,
  setGoToVerify,
  success,
  handleRefresh,
  handleOpen,
  setHandleOpen,
  status,
  setVerificarionOpen,
  fees,
  setPayment,
}) => {
  const [balance, setBalance] = useState("");
  const { auth } = useAuth();
  const [feeMessage, setFeeMessage] = useState("");
  const [prevBalance, setPrevBalance] = useState([]);
  const [intervalId, setIntervalId] = useState(null);
  const [showPayPal, setShowPayPal] = useState(false);
  const [showStripe, setShowStripe] = useState(false);
  const [stripToken, setStripToken] = useState("");
  const [kycStatus, setKycStatus] = useState(false);
  const [kycLimit, setKycLimit] = useState(0);
  const [kycActive, setKycActive] = useState("");
  const [errorMessageApi, setErrorMessageApi] = useState("");
  const [errorKYC, setErrorKYC] = useState("");
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [submitAction, setSubmitAction] = useState(null);
  const [showMessage, setShowMessage] = useState("");
  const [showMessageError, setShowMessageError] = useState("");
  const [isClicked, setIsClicked] = useState(false);
  const [userProfileData, setUserProfileData] = useState("");
  const [title, settitle] = useState("Choose your payment method");
  const { ValueLoad, ValueSecondaryLoad } = useContext(Context);
  const [isBlocked, setIsBlocked] = useState(false);
  const [depositManualShow, setDepositManualShow] = useState(false);
  const [depositVenmoShow, setDepositVenmoShow] = useState(false);
  const [amountLimit, setAmountLimit] = useState({});
  const [amountError, setAmountError] = useState("");
  const [amountLoading, setAmountLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [bankDetails, setBankDetails] = useState({});
  const [methodData, setMethodData] = useState({ show: false, data: "" });
  // FORMIK WORK
  const initialValues = {
    amount: "",
    currency: "USD",
    email: "",
  };

  const getToken = async () => {
    try {
      const profileRes = await getProfile();
      setKycStatus(profileRes?.data?.kyc_status);
      setIsBlocked(profileRes?.data?.is_blocked);
    } catch (error) {
      console.error(
        error.message || "An error occurred In Token & Prifile Section"
      );
    }
  };

  const paymentTransaction = async (request, responseData, type, userId) => {
    try {
      const payment = await payment_transaction(
        request,
        responseData,
        type,
        userId
      );
      console.log("payment", payment);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getUserProfileData = async () => {
    try {
      const userProfileData = await user_profile(auth.userId);
      setUserProfileData(userProfileData[0]);
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getToken();
    getBalance();
    getUserProfileData();
  }, []);

  useEffect(() => {
    getAuctionDefaultValues().then((data) => {
      if (data) {
        setKycLimit(data?.KYCLimit);
        setKycActive(data?.KYCActive);
      }
    });
  }, []);

  // PAYPAL DEPOSIT FUNCTION
  const handleDeposit = async (paymentResult) => {
    try {
      const response = await addDeposit(paymentResult);
      paymentTransaction(
        paymentResult,
        response,
        "add funds step2 sent Antier Data",
        auth?.userId
      );
      if (response && response?.status === 200) {
        if (setPayment) {
          setPayment(true);
          ValueLoad(true);
          ValueSecondaryLoad(true);
        }
        getBalance();
        setShowMessage(
          "Your Payment is being processed and can take up to 5 minutes to appear in your wallet. You can see the record of this transaction and the balance of your wallet in the "
        );
        if (success) {
          setSuccessfullTransaction(
            paymentResult.purchase_units[0]?.amount.value
          );
        }
      } else {
        setShowMessageError(
          "Your funds could not be sent. Please contact an administrator."
        );
      }
      if (handleRefresh) {
        handleRefresh();
      }
      return true;
    } catch (error) {
      console.error("Error depositing:", error);
    }
  };

  // PAYPAL HANDLE ERROR
  function onError(error) {
    setShowMessageError(
      "Your payment was unsuccessful. Please try again later."
    );
    paymentTransaction(
      error,
      error,
      "add funds step1 sent Paypal Data",
      auth?.userId
    );
    paymentTransaction(
      "The paypal process has failed",
      "The paypal process has failed",
      "add funds step2 sent Antier Data",
      auth?.userId
    );
  }

  useEffect(() => {
    const handleAmountLimit = async () => {
      try {
        setAmountLoading(true);
        setAmountError(null);
        const res = await depositWithdrawAmountLimit();
        if (res?.status === 200 || res?.status === 201) {
          setAmountLimit(res?.data);
        } else {
          setAmountError("Failed to fetch Amount Limit");
        }
      } catch (error) {
        setAmountError(error?.message || "Something went wrong");
      } finally {
        setAmountLoading(false);
      }
    };

    handleAmountLimit();
  }, []);

  // CLOSE MODAL
  function closeModal() {
    setHandleOpen(false);
    setShowPayPal(false);
    setShowStripe(false);
    setShowMessage("");
    settitle("Choose your payment method");
  }

  const validationSchema = Yup.object({
    amount: Yup.string()
      // .matches(/^\d+$/, "Amount must contain only digits")
      .required("Amount is required")
      .test(
        "is-valid-amount",
        "Amount must be a positive number",
        (value) => parseFloat(value) > 0
      )
      .test(
        "min-amount",
        `The minimum amount must be at least $ ${formatCommaNumbers(
          amountLimit?.deposit?.min
        )}`,
        (value) => {
          if (!value) return false;
          const amount = parseFloat(value.replaceAll(/,/g, ""));
          return amount >= amountLimit?.deposit?.min;
        }
      )
      .test(
        "max-amount",
        `The maximum amount be must less than $ ${formatCommaNumbers(
          amountLimit?.deposit?.max
        )}`,
        (value) => {
          if (!value) return false;
          const amount = parseFloat(value.replaceAll(/,/g, ""));
          return amount <= amountLimit?.deposit?.max;
        }
      )
      .test(
        "max-demimal-amount",
        "The maximum number of decimals places is 2",
        (value) => {
          if (!value) return false;
          if (value.includes(".")) {
            const decimals = value.split(".")[1].length;
            if (decimals > 2) return false;
          }
          return true;
        }
      ),
    currency: Yup.string().required("Currency is Required"),
    email: Yup.string()
      .trim()
      .email("Invalid email address")
      .when("$status", {
        is: (val) => val !== "Add",
        then: Yup.string().required("Email is required"),
        otherwise: Yup.string(),
      }),
  });

  const handleContinueClick = (amount, errors, method) => {
    if (amount.length === 0) {
      return;
    }
    if (errors.length > 1) {
      return;
    }
    //Only when the account is verified
    if (kycStatus !== "APPROVED") {
      const sanitizedkyc = kycLimit?.replace(/,/g, "");
      const kyc = parseFloat(sanitizedkyc);
      const sanitizedAmount = amount.replace(/,/g, "");
      const parseAmount = parseFloat(sanitizedAmount);
      const walletMoney = balance[0]?.available_cash;
      const walletMoneyNum = parseFloat(walletMoney);
      const walletMoneyRestricted = balance[0]?.restricted_cash;
      const walletMoneyNumRestricted = parseFloat(walletMoneyRestricted);
      const exededLimit =
        walletMoneyNum + parseAmount + walletMoneyNumRestricted;

      if (exededLimit > kyc && kycActive === "True") {
        setGoToVerify(true);
        setHandleOpen(false);
      } else {
        if (method === "paypal") {
          setShowPayPal(true);
        } else {
          setShowStripe(true);
        }
        setVerificarionOpen(false);
      }
    } else {
      if (method === "paypal") {
        setShowPayPal(true);
      } else {
        setShowStripe(true);
      }
      setVerificarionOpen(false);
      if (handleRefresh) {
        handleRefresh();
      }
    }
  };

  const onSubmit = async (values) => {
    try {
      const { amount, currency, email } = values;
      const amountWithoutCommas = values.amount.replace(/,/g, "");
      const withdrawPayload = {
        amount: {
          value: amountWithoutCommas,
          currency: values?.currency,
        },
        receiver: email,
        beneficiaryName: userProfileData.user_firstname || "",
        bankCountry: userProfileData.bank_country,
        accountNumber: userProfileData.user_accountNumber || "",
        ABA: userProfileData.user_ABA || "",
        routingNumber: userProfileData.user_routingNumber || "",
        bankAddressline1: userProfileData.user_bankAddressline1 || "",
        bankState: userProfileData.bank_state || "",
        bankCity: userProfileData.bank_city || "",
        bankZipCode: userProfileData.user_bankZipCode || "",
        country: userProfileData.user_country || "",
        addressline1: userProfileData.user_addressline1 || "",
        phonenumber: userProfileData.user_phonenumber || "",
        city: userProfileData.user_city || "",
        state: userProfileData.user_state || "",
        zipcode: userProfileData.user_zipcode || "",
      };
      if (kycStatus === "PENDING") {
        setErrorKYC("User KYC is not completed!");
        return;
      }
      const withdrawRes = await addWithdraw(withdrawPayload);
      if (withdrawRes?.message && withdrawRes?.status !== 200) {
        setErrorMessageApi(withdrawRes?.message);
        return;
      } else {
        setErrorMessageApi("");
      }
      if (withdrawRes) {
        await getBalance();
        setShowMessage(
          "Your Payment is being processed and can take up to 5 minutes to appear in your wallet. You can see the record of this transaction and the balance of your wallet in the "
        );
      }
      setErrorKYC("");
      if (handleRefresh) {
        handleRefresh();
      }
    } catch (error) {
      console.error("Error during withdrawal:", error);
    }
  };

  const getBalance = async () => {
    try {
      const walletRes = await getWalletBalance();
      const newBalance = walletRes?.data;
      setBalance(newBalance);

      if (JSON.stringify(newBalance) !== JSON.stringify(prevBalance)) {
        setPrevBalance(newBalance);
        clearInterval(intervalId);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  const handleKeyDown = (event, formik) => {
    try {
      if (event.key === "Enter") {
        if (status === "Add") {
          event.preventDefault();
          handleContinueClick(formik.values.amount, Object.keys(formik.errors));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = () => {
    setOpenConfirmation(false);
    submitAction();

    if (handleRefresh) {
      handleRefresh();
    }
  };

  const handleCancelSubmit = () => {
    setOpenConfirmation(false);
  };

  const openModalConfirmation = async (submit, formik) => {
    const errors = await formik.validateForm();

    if (kycStatus !== "APPROVED") {
      setVerificarionOpen(true);
      closeModal();
    } else {
      if (Object.keys(errors).length === 0) {
        setSubmitAction(() => submit);
        setOpenConfirmation(true);
        togglePaymentStatus();
        ValueLoad(true);
        ValueSecondaryLoad(true);
      } else {
        formik.setTouched(
          Object.keys(errors).reduce((acc, key) => {
            acc[key] = true;
            return acc;
          }, {})
        );
        console.log("There are errors in the validations:", errors);
      }
    }
  };

  const togglePaymentStatus = () => {
    localStorage.setItem("isPaymentSuccessful", "true");
    console.log("Pago registrado en localStorage");
  };

  return (
    <Modal
      isOpen={handleOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <CMCloseButton onClick={closeModal}>
        <CloseIcon width={16} height={16} />
      </CMCloseButton>
      {!showPayPal && !showStripe ? (
        <>
          <Title className="title">
            {status === "Add" ? (
              <h2>My Account</h2>
            ) : (
              <h2>Withdrawal Request</h2>
            )}
          </Title>
        </>
      ) : (
        <>
          <Title className="title">
            <h2>{title}</h2>
          </Title>
        </>
      )}

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => {
          const { submitForm, values, errors } = formik;
          return (
            <Form
              //
              className={`form-container withdraw-form ${
                !showPayPal ? "" : "withdraw_payment"
              }`}
              onKeyDown={(event) => handleKeyDown(event, formik)}
            >
              {amountLoading ? (
                <LoadingChild />
              ) : (
                !showPayPal &&
                !showStripe &&
                !showMessage &&
                amountLimit?.deposit && (
                  <>
                    <div className="form-group">
                      <div className="box">
                        <div className="inputGroup">
                          <label className="form-label">
                            Transfer Amount{" "}
                            <span className="error-caption">*</span>
                          </label>
                          <div className="transferInput">
                            {status === "Withdraw" ? (
                              <div className="dollar-sign">$</div>
                            ) : (
                              <>
                                <div className="dollar-sign">$</div>
                                <Field
                                  as="select"
                                  name="currency"
                                  className="input-field"
                                >
                                  <option disabled value=""></option>
                                  <option value="USD">USD</option>
                                  {/* <option value="MXN">MXN</option> */}
                                </Field>
                              </>
                            )}
                            <InputMoneyField
                              className="form-control"
                              name="amount"
                              placeholder="100"
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onPaste={(event) => {
                                const pastedData =
                                  event.clipboardData.getData("text");

                                if (!/^\d+$/.test(pastedData)) {
                                  event.preventDefault();
                                }
                              }}
                              onInput={(event) => {
                                const inputValue = Number(
                                  event?.target?.value.replace(/[^0-9]/g, "")
                                );
                                const feePercentage =
                                  status === "Withdraw"
                                    ? fees?.fees?.withdraw_fee
                                    : fees?.fees?.deposit_fee;
                                if (fees?.fees) {
                                  if (inputValue) {
                                    const onePercent =
                                      inputValue * (feePercentage / 100);
                                    const finalAmount = inputValue - onePercent;
                                    setFeeMessage(
                                      <>
                                        <span
                                          style={{
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          Platform Fees: {feePercentage}%.
                                        </span>
                                        <br />
                                        <span
                                          style={{
                                            fontSize: "12px",
                                            color: "#555",
                                          }}
                                        >
                                          You Will Get:{" "}
                                          <strong>
                                            ${formatCommaNumbers(finalAmount)}
                                          </strong>
                                        </span>
                                        <br />
                                        {""}
                                        <br />
                                      </>
                                    );
                                  } else {
                                    setFeeMessage("");
                                  }
                                }
                                event.target.value = event.target.value.replace(
                                  /[^0-9]/g,
                                  ""
                                );
                              }}
                              autocomplete="off"
                            />
                          </div>
                          <p className="error">
                            <ErrorMessage name="currency" />
                          </p>
                          <p className="error">
                            <ErrorMessage name="amount" />
                          </p>
                        </div>
                        {feeMessage}
                        {status === "Withdraw" && (
                          <>
                            <div className="inputGroup">
                              <label className="form-label">
                                Enter the email address associated with your
                                PayPal account.
                                <span className="error-caption">*</span>
                              </label>
                              <Field
                                type="email"
                                name="email"
                                placeholder=" Enter email"
                                className="form-control"
                              />
                              <p className="error">{errorKYC}</p>
                              <p className="error">
                                <ErrorMessage name="email" />
                              </p>
                            </div>
                          </>
                        )}
                      </div>
                      {status === "Withdraw" && (
                        <h6>
                          For your protection and to prevent fraud, all requests
                          are reviewed for safety. Once approved, your funds
                          will appear in your account, and a notification will
                          be sent to your email.
                        </h6>
                      )}
                    </div>
                    {!showPayPal && !showStripe && status !== "Withdraw" && (
                      <>
                        <div
                          style={{
                            textAlign: "center",
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "space-evenly",
                          }}
                        >
                          <button
                            type="button"
                            className="action-button"
                            onClick={() => {
                              handleContinueClick(
                                formik.values.amount,
                                Object.keys(formik.errors),
                                "paypal"
                              );
                            }}
                            disabled={isBlocked}
                          >
                            Continue
                          </button>
                          {isBlocked ? (
                            <p style={{ color: "red", textAlign: "center" }}>
                              Your Account is Blocked, Please contact admin
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      </>
                    )}
                    {status === "Withdraw" && (
                      <div>
                        <p className="error">{errorMessageApi}</p>
                        <button
                          type="button"
                          onClick={() =>
                            openModalConfirmation(submitForm, formik)
                          }
                          className="action-button"
                        >
                          Submit
                        </button>
                      </div>
                    )}
                  </>
                )
              )}

              {amountError && <p style={{ color: "red" }}>{amountError}</p>}
              {formik.values.amount &&
                formik.values.currency &&
                showPayPal &&
                !showStripe &&
                !showMessage &&
                !showMessageError &&
                status === "Add" && (
                  <div
                    className={
                      isClicked
                        ? "withdraw_payment remove_space"
                        : "withdraw_payment"
                    }
                  >
                    {amountLimit?.deposit?.methods?.map((method) => {
                      return (
                        method?.name === "Paypal" &&
                        method?.status &&
                        method?.action === "gateway" && (
                          <PayPalButtons
                            // fundingSource={FUNDING.PAYPAL}
                            // fundingSource={undefined}
                            createOrder={(data, actions) => {
                              const amountWithoutCommas =
                                formik?.values?.amount.replace(/,/g, "");
                              const amount = parseFloat(amountWithoutCommas);

                              const orderDetails = {
                                purchase_units: [
                                  {
                                    reference_id: balance[0]?.user_id,
                                    amount: {
                                      value: amount,
                                      currency: formik?.values?.currency,
                                    },
                                  },
                                ],
                              };
                              return actions?.order?.create(orderDetails);
                            }}
                            onApprove={(data, actions) => {
                              const amountWithoutCommas =
                                formik?.values?.amount.replace(/,/g, "");
                              const amount = parseFloat(amountWithoutCommas);
                              const orderDetails = {
                                purchase_units: [
                                  {
                                    reference_id: balance[0]?.user_id,
                                    amount: {
                                      value: amount,
                                      currency: formik?.values?.currency,
                                    },
                                  },
                                ],
                              };
                              return actions.order.capture().then((details) => {
                                paymentTransaction(
                                  orderDetails,
                                  details,
                                  "add funds step1 sent Paypal Data",
                                  auth?.userId
                                );
                                handleDeposit(details);
                              });
                            }}
                            onClick={() => {
                              setIsClicked(true);
                            }}
                            onError={(error) => {
                              console.error("Detected error:", error);
                              if (
                                error &&
                                error.message &&
                                error.message.includes("Detected popup close")
                              ) {
                                return;
                              }
                              onError(error);
                            }}
                          />
                        )
                      );
                    })}
                     {amountLimit?.deposit?.methods?.map((method) => {
                      return (
                        method?.status === true &&
                        method?.action === "manual"  && (
                          <Button
                            type="button"
                            className="manualDeposit-style-button bank-transfer-btn"
                            disabled={isBlocked}
                            onClick={() => {
                              setAmount(
                                parseFloat(
                                  formik.values.amount.replace(/,/g, "")
                                )
                              );
                              setMethodData({ show: true, data: method });
                            }}
                          >
                            {method?.name}
                          </Button>
                        )
                      );
                    })}
                    {amountLimit?.deposit?.methods?.every(
                      (method) => method?.status === false
                    ) && (
                      <p style={{ color: "red", textAlign: "center" }}>
                        Currently, no deposit methods have been enabled by the
                        admin.
                      </p>
                    )}{" "}
                    {/* <Button
                      type="button"
                      className="manualDeposit-style-button stripe_btn"
                      disabled={isBlocked}
                      onClick={() => {
                        handleContinueClick(
                          formik.values.amount,
                          Object.keys(formik.errors),
                          "stripe"
                        );
                        setIsClicked(true);
                      }}
                    >
                      <StripeIcon />
                    </Button> */}
                  </div>
                )}
              {formik.values.amount &&
                formik.values.currency &&
                showStripe &&
                !showMessage &&
                !showMessageError &&
                status === "Add" && (
                  <div
                    className={
                      isClicked
                        ? "withdraw_payment remove_space"
                        : "withdraw_payment"
                    }
                  >
                    <MainStripe
                      setStripToken={setStripToken}
                      amount={parseFloat(
                        formik.values.amount.replace(/,/g, "")
                      )}
                      currency={formik.values.currency}
                      type={"DEPOSIT"}
                    />
                  </div>
                )}
              {/* {formik.values.amount &&
                formik.values.currency &&
                showStripe &&
                !showMessage &&
                !showMessageError &&
                status === "Add" && (
                  <div
                    className={
                      isClicked
                        ? "withdraw_payment remove_space"
                        : "withdraw_payment"
                    }
                  >
                    <MainStripe
                      setStripToken={setStripToken}
                      amount={parseFloat(
                        formik.values.amount.replace(/,/g, "")
                      )}
                      currency={formik.values.currency}
                      type={"DEPOSIT"}
                    />
                  </div>
                )} */}
              {showMessage && (
                <>
                  {settitle("Add Funds")}
                  <div className="form-group">
                    <div>
                      <p className="message-postPay">
                        {showMessage}{" "}
                        <Link
                          onClick={() => {
                            closeModal();
                          }}
                          className="link"
                          to={"/billing-history"}
                        >
                          transaction history section
                        </Link>
                      </p>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="action-button"
                        onClick={() => {
                          closeModal();
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </>
              )}

              {showMessageError && (
                <>
                  {settitle("Add funds")}
                  <div className="form-group">
                    <div>
                      <p className="message-postPay">{showMessageError} </p>
                    </div>
                    <div>
                      <button
                        type="button"
                        className="action-button"
                        onClick={() => {
                          closeModal();
                        }}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </>
              )}
            </Form>
          );
        }}
      </Formik>
      {methodData?.show && (
        <MethodModal
          show={methodData?.show}
          setShow={setMethodData}
          setHandleOpen={setHandleOpen}
          amount={amount}
          data={methodData?.data}
        />
      )}

      <Modal isOpen={openConfirmation} style={customStylesConfirmationModal}>
        <CMModalConfirmation>
          <Title className="title">
            <h2>Confirm</h2>
          </Title>
          <label className="description_confirmation">
            Are you sure the email used is linked to a PayPal account?
          </label>
          <div className="container_buttons">
            <button className="button_accept" onClick={handleSubmit}>
              Yes
            </button>
            <button className="button_reject" onClick={handleCancelSubmit}>
              No
            </button>
          </div>
        </CMModalConfirmation>
      </Modal>
    </Modal>
  );
};

export default AddFunds;

export const InputMoneyField = ({ ...props }) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);

  const handleChange = (event) => {
    let { value } = event.target;
    const strippedValue = value.replace(/[^\d.]/g, "");
    let [integerPart, decimalPart] = strippedValue.split(".");
    if (integerPart === "") {
      integerPart = "0";
    }
    const formattedIntegerPart = parseInt(integerPart, 10).toLocaleString(
      "en-US"
    );
    const formattedValue =
      decimalPart !== undefined
        ? `${formattedIntegerPart}.${decimalPart}`
        : formattedIntegerPart;
    setFieldValue(field.name, strippedValue === "" ? "" : formattedValue);
    event.target.value = formattedValue;
  };

  return <input {...field} {...props} type="text" onChange={handleChange} />;
};
